import {
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast"
import { TOAST_DISMISS_DELAY, useToast } from "./useToast"

// End-to-end tests fail any signed-in test that leaves a toast with this id showing.
const ERROR_TOAST_TEST_ID = "error-toast"

function Toaster() {
  const { toasts, dismiss, remove } = useToast()

  return (
    <ToastProvider>
      {toasts.map(
        ({ id, variant, title, description, icon, action, duration, open }) => (
          <Toast
            key={id}
            variant={variant}
            data-testid={variant === "danger" ? ERROR_TOAST_TEST_ID : undefined}
            icon={icon}
            open={open}
            duration={duration ?? TOAST_DISMISS_DELAY}
            className="cursor-pointer"
            onClick={() => dismiss(id)}
            onOpenChange={(isOpen) => {
              if (!isOpen) {
                remove(id)
              }
            }}
          >
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
            {action && (
              <ToastAction altText={action.label} onClick={action.onClick}>
                {action.label}
              </ToastAction>
            )}
            <ToastClose />
          </Toast>
        ),
      )}
      <ToastViewport />
    </ToastProvider>
  )
}

export { Toaster }
